export var PriceLayoutEnum;
(function (PriceLayoutEnum) {
    PriceLayoutEnum["DEFAULT"] = "DEFAULT";
    PriceLayoutEnum["GERMAN_SALE"] = "GERMAN_SALE";
    PriceLayoutEnum["GERMAN_RENT"] = "GERMAN_RENT";
    PriceLayoutEnum["FRENCH_SALE"] = "FRENCH_SALE";
})(PriceLayoutEnum || (PriceLayoutEnum = {}));
export var PriceSectionBreakdownColorType;
(function (PriceSectionBreakdownColorType) {
    PriceSectionBreakdownColorType["MAIN_PRICE"] = "MAIN_PRICE";
    PriceSectionBreakdownColorType["PARKING_PRICE"] = "PARKING_PRICE";
    PriceSectionBreakdownColorType["NOTARY_FEE"] = "NOTARY_FEE";
    PriceSectionBreakdownColorType["REAL_ESTATE_TRANSFER_TAX"] = "REAL_ESTATE_TRANSFER_TAX";
    PriceSectionBreakdownColorType["BROKERAGE_FEE"] = "BROKERAGE_FEE";
    PriceSectionBreakdownColorType["LAND_REGISTRY_ENTRY"] = "LAND_REGISTRY_ENTRY";
    PriceSectionBreakdownColorType["BASE_RENT"] = "BASE_RENT";
    PriceSectionBreakdownColorType["OPERATING_COSTS"] = "OPERATING_COSTS";
    PriceSectionBreakdownColorType["HEATING_COSTS"] = "HEATING_COSTS";
    PriceSectionBreakdownColorType["PARKING_RENT"] = "PARKING_RENT";
    PriceSectionBreakdownColorType["VALUE_ADDED_TAX"] = "VALUE_ADDED_TAX";
})(PriceSectionBreakdownColorType || (PriceSectionBreakdownColorType = {}));
